// Quiz helper functions matching Angular quizHelper.getQuizResults

export function getQuizResults(answers, selectionData) {
  if (!answers || !selectionData || selectionData.length === 0) {
    return [];
  }

  // Convert answers to the format expected by selection matching
  const answerKeys = Object.keys(answers).sort();

  // Find matching rows in selection data
  const matchedRows = selectionData.filter((row, index) => {
    let matches = true;
    const debugInfo = { rowIndex: index, rowId: row.id };

    for (const questionKey of answerKeys) {
      const answer = Array.isArray(answers[questionKey])
        ? answers[questionKey][0]
        : answers[questionKey];
      if (!answer || answer === "skip") {
        continue;
      }
      // Match "unsure" explicitly - don't skip it
      if (row[questionKey] && row[questionKey] !== answer) {
        debugInfo[
          `${questionKey}_mismatch`
        ] = `expected:${answer}, got:${row[questionKey]}`;
        matches = false;
        break;
      } else {
        debugInfo[`${questionKey}_match`] = answer;
      }
    }

    return matches;
  });

  // Merge quiz answers and SKU/product keys into a single result row (first match)
  if (matchedRows.length === 0) {
    return [];
  }
  const row = matchedRows[0];
  const merged = { ...row };
  // Add quiz answers explicitly (for clarity)
  for (const key of answerKeys) {
    merged[key] = Array.isArray(answers[key]) ? answers[key][0] : answers[key];
  }
  return [merged];
}

export function processQuizResults(quizResults) {
  if (!quizResults || quizResults.length === 0) {
    return { groups: [], type: "standard" };
  }

  const resultRow = quizResults[0];
  const groups = ["best-solution", "additional-products"];
  const queries = [];

  Object.keys(resultRow).forEach((key) => {
    const parts = key.split(":");
    if (
      resultRow[key] != null &&
      parts.length > 0 &&
      groups.includes(parts[0])
    ) {
      if (parts[1].match(/-antibodies$/i)) {
        queries.push({
          group: parts[0],
          category: parts[1],
          type: "search",
          searchType: parts[1] === "primary-antibodies" ? "typeahead" : "text",
          path: resultRow[key],
        });
      } else if (
        parts[1].match(/recombinant-proteins$/i) ||
        parts[1].match(/antibody-pairs$/i)
      ) {
        queries.push({
          group: parts[0],
          category: parts[1],
          type: "button",
          path: resultRow[key],
        });
      } else {
        queries.push({
          group: parts[0],
          category: parts[1],
          type: "product",
          sku: resultRow[key],
        });
      }
    }
  });

  return queries;
}
